import cx from 'classnames';
import React from 'react';
import type { PageProps } from './page';
import { Page } from './page';

export const Construction = (props: Pick<PageProps, 'className' | 'reset'>): React.ReactElement => (
  <Page
    icon='fa-construction'
    className={cx(props.className, 'text-white')}
    heading='Under Construction'
    message='Oops! This page is still being built.<br />Check back again soon.'
    {...props}
  />
);
